import { Injectable } from '@angular/core';
import { NgpDatePickerState } from 'ng-primitives/date-picker';

@Injectable({
  providedIn: 'root',
})
export class DatePickerUtilsService {
  /**
   * Check if a given date is today.
   * @param date The date to check.
   * @returns True if the date is today, false otherwise.
   */
  isToday(date: Date): boolean {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  /**
   * Check if a given date is selected.
   * @param date The date to check.
   * @param state The state of the date picker.
   * @returns True if the date is selected, false otherwise.
   */
  isSelected(date: Date, state: NgpDatePickerState<Date>): boolean {
    return (
      state.date()?.getFullYear() === date.getFullYear() &&
      state.date()?.getMonth() === date.getMonth() &&
      state.date()?.getDate() === date.getDate()
    );
  }
}
